import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { variables } from '@resurs/midas'
import { Container, Columns, Column } from '@resurs/midas-react'

import { getText } from '../TextLabels'

const commonStyles = {
  borderBottom: '1px solid rgba(0,0,0,0.12)',
  padding: '1rem',
  background: '#f5f5f5',
}
const transparentStyles = {
  background: '#fafafa',
}

const PageActionBar = ({ items, actions, showPrev, history, transparent }) => {
  const styles = transparent ? transparentStyles : commonStyles

  return (
    <Container>
      <Columns>
        <Column col12 noPadding>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flex: '1 1 auto',
              ...styles,
            }}
          >
            {showPrev && (
              <button
                style={{
                  margin: '-0.8rem',
                  minHeight: '3.8rem',
                  padding: '0.7rem 1.7rem',
                  fontFamily: variables.headerFontFamily,
                  border: `1px solid ${variables.coreBorderColor}`,
                  background: 'transparent',
                  cursor: 'pointer',
                }}
                onClick={e => {
                  e.preventDefault()
                  history.goBack()
                }}
                type="button"
              >
                <svg
                  fillRule="evenodd"
                  height={12}
                  width={8}
                  viewBox="0 0 8 12"
                >
                  <path d="M7.5 10.6L2.8 6l4.7-4.6L6.1 0 0 6l6.1 6z" />
                </svg>
                <span style={{ paddingLeft: '.7rem' }}>
                  {getText('default.back')}
                </span>
              </button>
            )}
            <div style={{ marginTop: '-1rem' }}>{items}</div>
            <div style={{ marginLeft: 'auto' }}>{actions}</div>
          </div>
        </Column>
      </Columns>
    </Container>
  )
}

PageActionBar.propTypes = {
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  actions: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  showPrev: PropTypes.bool,
  history: PropTypes.object.isRequired,
  transparent: PropTypes.bool,
}

PageActionBar.defaultProps = {
  showPrev: false,
  items: null,
  actions: null,
  transparent: false,
}

export default withRouter(PageActionBar)
